ACC.refinements = {

    bindAll: function () {
        this.bindRefinementCategoryToggles();
        this.toggleRefinementCategories();
        this.bindMoreLessToggles();
        this.bindMoreStoresToggles();
        this.bindFacetValueSearches();
        this.submitRangeForm();
    },

    bindRefinementCategoryToggles: function () {
        $('a.refinementToggle').each(function () {
            $(this).attr('title', $(this).data('showFacetText'));

            $(this).on("click", function () {
                ACC.refinements.toggleRefinementCategory($(this));

                var expandedRefinementToggles = JSON.parse(localStorage.getItem("expandedRefinementToggles"));
                var refinementToggleName = this.innerText;
                var index = expandedRefinementToggles.indexOf(refinementToggleName);
                if ($(this).hasClass("closed")) {
                    if (index > -1) {
                        expandedRefinementToggles.splice(index, 1);
                    }
                } else {
                    if (index == -1) {
                        expandedRefinementToggles.push(refinementToggleName);
                    }
                }
                localStorage.setItem("expandedRefinementToggles", JSON.stringify(expandedRefinementToggles));
                return false;
            });

            $(this).next().click(function () {
                $(this).prev().click();
            });
        });
    },

    toggleRefinementCategory: function (refinementCategory) {
        var content = refinementCategory.parents('.facet').find('div.facetValues');
        refinementCategory.attr('title', $(content).is(':visible') ? refinementCategory.data('showFacetText') : refinementCategory.data('hideFacetText'));
        refinementCategory.toggleClass("closed");
        $(content).slideToggle();
    },

    toggleRefinementCategories: function () {
        if (localStorage.getItem("expandedRefinementToggles") == null) {
            // initialize local storage
            localStorage.setItem("expandedRefinementToggles", JSON.stringify([]));
        } else {
            // restore expanded refinement toggles
            var expandedRefinementToggles = JSON.parse(localStorage.getItem("expandedRefinementToggles"));
            expandedRefinementToggles.forEach(function (element) {
                var refinementToggle = $("a.refinementToggle:contains('" + element + "')");
                ACC.refinements.toggleRefinementCategory(refinementToggle);
            });
        }
    },

    bindMoreLessToggles: function () {
        $("a.moreFacetValues").click(function (e) {
            e.preventDefault();

            var eParent = $(this).parents(".facetValues");
            eParent.find(".topFacetValues").hide();
            eParent.find(".allFacetValues").show();
        });

        $("a.lessFacetValues").click(function (e) {
            e.preventDefault();

            var eParent = $(this).parents(".facetValues");
            eParent.find(".topFacetValues").show();
            eParent.find(".allFacetValues").hide();
        })
    },

    bindMoreStoresToggles: function () {
        $("a.moreStoresFacetValues").click(function (e) {
            e.preventDefault();

            $(this).parents('div.allFacetValues').find('li.hidden').slice(0, 5).removeClass('hidden').first().find('input:[type=checkbox]').focus();
        })

    },

    bindFacetValueSearches: function () {
        $(".js-clearFacetValueSearchButton").on("kloeckner.clearButtonClicked", function (e, oldClearInputValue) {
            var clearButton = $(this);
            
            var clearInput = clearButton.prev(".js-facetValueSearchInput");
            var facetValuesContainer = clearButton.closest(".js-facetValuesContainer");
            
            clearTimeout(clearInput.data('timer'));
            facetValuesContainer.find(".js-noSearchResultMessage").fadeOut();
            
            if (oldClearInputValue) {
                facetValuesContainer.find("li").hide();
                facetValuesContainer.find("li").fadeIn();
            }
        });

        $(".js-facetValueSearchInput").on("kloeckner.clearInputTextChanged", function (e) {
            var clearInput = $(this);
            
            clearTimeout(clearInput.data('timer'));
            var wait = setTimeout(function() {
                    ACC.refinements.filterFacetValues(clearInput);
                }, 450);
            clearInput.data('timer', wait);
        });
    },
    
    filterFacetValues: function(inputField) {
        var facetValuesContainer = inputField.closest(".js-facetValuesContainer");

        facetValuesContainer.find("li").hide();
        facetValuesContainer.find(".js-noSearchResultMessage").fadeOut();

        var enteredText = inputField.val();
        if (enteredText) {
            enteredText = enteredText.toLowerCase();

            facetValuesContainer.find("span[data-text^='" + enteredText + "']").closest("li").fadeIn();
        } else {
            facetValuesContainer.find("li").fadeIn();
        }
        
        if (facetValuesContainer.find("li:visible").length <= 0) {
            facetValuesContainer.find(".js-noSearchResultMessage").fadeIn();
        }
    },
    
    submitRangeForm: function() {
        $('.js-range-form').on('submit', function(event) {
            var select = $(this).find('select');
            
            // Disable select with empty value to not submit it.
            if (!select.val()) {
                select.prop('disabled', true);
            }
        });
    }
};

$(document).ready(function () {
    ACC.refinements.bindAll();
});
